import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesEnum } from '../enums/routes-enum';
import { AuthService } from '../services/auth.service';
import { SharedServiceService } from '../services/shared-service.service';

@Component({
  selector: 'app-side-bar-marchand',
  templateUrl: './side-bar-marchand.component.html',
  styleUrls: ['./side-bar-marchand.component.css']
})
export class SideBarMarchandComponent implements OnInit{
   tokenKey: string = 'authToken';
  constructor(private sharedService: SharedServiceService,private  authService: AuthService, private router: Router) {}

  ngOnInit() {
  this.startTokenTimer();
}

private startTokenTimer() {
  const token = localStorage.getItem(this.tokenKey);
  if (!token) return;

  const jwtPayload = JSON.parse(atob(token.split('.')[1]));
  const expiresAt = jwtPayload.exp * 1000; // timestamp en ms
  const timeout = expiresAt - Date.now();

  if (timeout <= 0) {
    this.logout();
  } else {
    setTimeout(() => this.logout(), timeout);
  }
}
  newMessage(title: string) {
    this.sharedService.changeMessage(title);
  }
  logout(){
    this.authService.logout();
    this.router.navigate([RoutesEnum.signinRouteM]);
  }
}
